import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID, Provider } from '@angular/core';

// nl-NL formattering voor de Angular date/number/currency/percent pipes (bv. "€ 49,95").
// Backend krijgt al x-language: nl via de localeInterceptor. Gedeeld door de standalone app
// (app.config) én het web-component embed (embed-providers) — beide root-injectors.
registerLocaleData(localeNl, 'nl-NL');

export const DUTCH_LOCALE_PROVIDER: Provider = { provide: LOCALE_ID, useValue: 'nl-NL' };
